import React from "react";
import Anonymous from "../Anonymous";
import StaticPageDetails from "../static_pages_admin/StaticPageDetails";

function LicenseAgreement() {
  return (
    <Anonymous>
      <StaticPageDetails slug="license"></StaticPageDetails>
    </Anonymous>
  );
}

export default LicenseAgreement;
